import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm font-semibold transition-all duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#007aff] focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 active:scale-[0.98]",
  {
    variants: {
      variant: {
        default:
          "bg-[#007aff] text-white rounded-xl hover:bg-[#0066d6] shadow-sm",
        destructive:
          "bg-[#ff3b30] text-white rounded-xl hover:bg-[#e6352b] shadow-sm",
        outline:
          "bg-white text-[#1d1d1f] border border-[rgba(0,0,0,0.12)] rounded-xl hover:bg-[#f5f5f7]",
        secondary:
          "bg-[#f5f5f7] text-[#1d1d1f] rounded-xl hover:bg-[#e8e8ed]",
        ghost: "text-[#1d1d1f] rounded-xl hover:bg-[#f5f5f7]",
        link: "text-[#007aff] underline-offset-4 hover:underline",
      },
      size: {
        default: "h-10 px-5 py-2",
        sm: "h-8 px-3 text-xs",
        lg: "h-12 px-8 text-base",
        icon: "h-10 w-10",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...props} />
  );
})
Button.displayName = "Button"

export { Button, buttonVariants }
